const DEFAULT_H = 80;
const HIDDEN_ATTR = 'data-header-hidden';

const getHeaderEl = () => (
  typeof document !== 'undefined' ? document.querySelector('[data-header-wrapper]') : null
);

export const getStickyHeaderHeightPx = () => {
  if (typeof document === 'undefined') return DEFAULT_H;

  const raw = getComputedStyle(document.documentElement).getPropertyValue('--header-height').trim();
  const parsed = parseInt(raw, 10);

  return Number.isFinite(parsed) && parsed > 0 ? parsed : DEFAULT_H;
};

/** Bottom edge of sticky chrome in viewport coords (`data-header-hidden` → 0). */
export const getStickyChromeBottomPx = () => {
  const el = getHeaderEl();

  if (!el) return getStickyHeaderHeightPx();
  if (el.getAttribute(HIDDEN_ATTR) === 'true') return 0;

  const rect = el.getBoundingClientRect();
  const live = Math.max(0, rect.bottom);
  const nominal = getStickyHeaderHeightPx();

  return rect.top <= 1 && rect.top >= -nominal && live < nominal ? nominal : live;
};

/** Live header bottom via transform; ignores `data-header-hidden` snap. */
export const getStickyChromeOverlapBottomPx = () => {
  const el = getHeaderEl();

  return el ? Math.max(0, el.getBoundingClientRect().bottom) : getStickyHeaderHeightPx();
};

export const getStickyChromeScrollMarginPx = () => getStickyChromeBottomPx();
